
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    setDoc,
  } from "firebase/firestore";

import { db } from "../apis/auth";

const collectionName = "devices";

export function getAllSLCDevices(type, ward = 0, zone = 0,ilm) {
    return new Promise((resolve, reject) => {
        // Start with the base query
        let queryObj = query(
            collection(db(), collectionName),
            where("dev_ty", "==", type)
        );

         if (zone !== 0) {
            queryObj = query(queryObj, where("zn", "==", zone));
        }
         if (ilm) {
            queryObj = query(queryObj, where("ilm", "==", ilm));
        }

         if (ward !== 0) {
            queryObj = query(queryObj, where("wd", "==", ward));
        }

        // Execute the query
        getDocs(queryObj)
            .then(querySnapshot => {
                const devices = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                resolve(devices);
            })
            .catch(error => {
                console.error(`Error fetching SLC devices: ${error}`);
                reject(error);  
            });
    });
}


export async function getSLCByDevId(ward, zone, devId) {

    var queryObj = query(
        collection(db(), collectionName),
        where("dev_ty", "==", 0),
        where("wd", "==", ward),
        where("zn", "==", zone),
        where("dev_id", "==", devId)
        );

    getDocs(queryObj).then((querySnapshot) => {
        Promise.resolve(querySnapshot);
    }).catch((error)=>{
        console.log(`====> Error fetch : ${error}`);
        Promise.reject(error);
    });
}


export async function getSLCByid(slc_id="") {

    var queryObj = query(
        collection(db(), collectionName),
       where("dev_ty", "==", 0),
        where("uid", "==", slc_id),
        );
    var result = null; 
   await getDocs(queryObj).then((querySnapshot) => {
    querySnapshot.forEach((doc)=>{
        result = doc.data();
    })
    }).catch((error)=>{
        console.log(`====> Error fetch : ${error}`);
    });
    if(result != null){
         return Promise.resolve(result);
    }
    return Promise.reject("docment not foun");
}

export async function getLampBySlcId(slc_id) {

    var queryObj = query(
        collection(db(), collectionName),
       where("dev_ty", "==", 1),
        where("slc_id", "==", slc_id),
        );
    var result = []; 
   await getDocs(queryObj).then((querySnapshot) => {
    querySnapshot.forEach((doc)=>{
        result.push(doc.data());
    })
    }).catch((error)=>{
        console.log(`====> Error fetch : ${error}`);
    });
    if(result != null){
        return Promise.resolve(result);
    }
    return Promise.reject("docment not foun");
}
export async function updateSlcData(docId, fieldName, data) {
      if (!docId || !fieldName || data === undefined) {
        return Promise.reject('Invalid input parameters');
    }
    try {
             const docRef = doc(db(), collectionName, docId);
            await updateDoc(docRef, { [fieldName]: data });
             return Promise.resolve();
      
    } catch (error) {
        console.error(`====> Error: ${error}`);
        return Promise.reject(error);
    }
}

export async function updateProjectMaintenanceData(projectsData) {
    if (!projectsData || !Array.isArray(projectsData)) {
        return Promise.reject('Invalid input: projectsData must be an array');
    }
     try {
        const docRef = doc(db(), 'settings', 'project');
        
         const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
             await updateDoc(docRef, { projects: projectsData });
        } else {
             await setDoc(docRef, { projects: projectsData });
        }
        
        return Promise.resolve();
    } catch (error) {
        console.error(`====> Error updating project maintenance data: ${error}`);
        return Promise.reject(error);
    }
}
// export async function updateSlcData(uid,fieldName,data) {
    
//     var queryObj = query(collection(db(), collectionName),where("uid", "==", uid),);
//     var result = null; 
//    await getDocs(queryObj).then((querySnapshot) => {
//     querySnapshot.forEach((doc)=>{
//         result = doc.id;
//     })
//     }).catch((error)=>{
//         console.log(`====> Error fetch : ${error}`);
//     });
//      if(result != null){
//         try {
//             const docRef = doc(db(), collectionName, result);
//             await updateDoc(docRef, { fieldName: data });
//             alert('Document successfully updated!');
//           } catch (error) {
//            alert(  error);
//           }
//     return Promise.resolve();
    
//     }
//     return Promise.error();
 
// }


// export async function updateDimScheduleInDevice(dimScheduleData) {
//     await getAllSLCDevices().then((querySnapshot) => {
//         // fosr
//     }).catch((error)=>{
//         console.log(`====> Error fetch : ${error}`);
//         Promise.reject(error);
//     });

//     const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
//     await updateDoc(docRef, dimScheduleData);
//     // if (docSnap.exists()) {
//         return Promise.resolve();
//     // }
//     // return Promise.reject("Unable to update dim schedule"); 
// }